import { render } from "./StatisticsPortalViewsCountTabs.vue?vue&type=template&id=6ec99b8a&ts=true"
import script from "./StatisticsPortalViewsCountTabs.vue?vue&type=script&lang=ts"
export * from "./StatisticsPortalViewsCountTabs.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__